import {
    EntityReactionType,
    ReactionCountType,
} from "@shared/Types/Reactions/ReactionTypes.types";
import { ReactionsNamesEnum } from "@shared/Types/Reactions/ReactionsNamesEnum";

export const reactions: ReactionType[] = [
    {
        name: ReactionsNamesEnum.LIKE,
        value: 1,
    },
    {
        name: ReactionsNamesEnum.LOVE,
        value: 1,
    },
    {
        name: ReactionsNamesEnum.LAUGH,
        value: 1,
    },
    {
        name: ReactionsNamesEnum.HUSHED,
        value: 1,
    },
    {
        name: ReactionsNamesEnum.SAD,
        value: -1,
    },
    {
        name: ReactionsNamesEnum.DISLIKE,
        value: -1,
    },
];

const reactionsObject = {
    [ReactionsNamesEnum.LIKE]: 1,
    [ReactionsNamesEnum.LOVE]: 1,
    [ReactionsNamesEnum.LAUGH]: 1,
    [ReactionsNamesEnum.HUSHED]: 1,
    [ReactionsNamesEnum.SAD]: -1,
    [ReactionsNamesEnum.DISLIKE]: -1,
};

export type ReactionType = {
    name: string;
    value: number;
};

export function mapToEntityReactions(
    entityReactionsCount: ReactionCountType,
): EntityReactionType[] {
    const entityReactions = [] as EntityReactionType[];
    if (!entityReactionsCount) return [] as EntityReactionType[];

    reactions.forEach((reaction) => {
        const entityReactionCount =
            entityReactionsCount[reaction.name as keyof ReactionCountType];

        if (!entityReactionCount) {
            return;
        }

        entityReactions.push({
            reactionName: reaction.name,
            reactionCount: entityReactionCount,
        });
    });
    return entityReactions;
}

export function getReactionCountFromReactionsArray(
    reactionsArray: EntityReactionType[],
    reactionName: ReactionsNamesEnum,
) {
    if (reactionsArray.length === 0) {
        return 0;
    }

    const desiredReactionObject = reactionsArray.find(
        (reaction) => reaction.reactionName === reactionName,
    );

    return desiredReactionObject?.reactionCount ?? 0;
}

export function getPositiveReactionsCountFromArray(
    reactionsArray: EntityReactionType[],
) {
    if (reactionsArray.length === 0) {
        return 0;
    }

    let count = 0;
    reactionsArray.forEach((currentReaction) => {
        const isPositiveReaction =
            reactionsObject[
                currentReaction.reactionName as keyof typeof reactionsObject
            ] > 0;

        count += isPositiveReaction ? currentReaction.reactionCount : 0;
    });

    return count;
}

export const convertToReactionCountObject = (
    reactionCountArray: EntityReactionType[],
) => {
    return {
        ...reactionCountArray.reduce(
            (accumulator, currentValue) => ({
                ...accumulator,
                [currentValue.reactionName]: currentValue.reactionCount,
            }),
            {},
        ),
    };
};

export const aggregateReactions = (reactionMap: Record<string, number>) => {
    return Object.values(reactionMap).reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0,
    );
};
